enum TextAlign {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right'
}
enum ButtonAlignment {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

export { TextAlign, ButtonAlignment };
